import z from "zod";

const BUILD0_AUTH_URL = process.env.BUILD0_AUTH_URL!;

/** Base auth structure from Build0 proxy */
const UserSchema = z
  .object({
    id: z.string(),
    email: z.string().email(),
    profilePictureUrl: z.string().url().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
  })
  .passthrough();

export type User = z.infer<typeof UserSchema>;

const AuthResponseSchema = z.object({
  user: UserSchema,
});

export async function authenticate(request: Request): Promise<{ user: User }> {
  // Fall back to fetching from endpoint
  // Get cookies from the request to forward for authentication
  const cookieHeader = request.headers.get("cookie");

  // Authenticate from endpoint with forwarded cookies
  const response = await fetch(BUILD0_AUTH_URL, {
    headers: { ...(cookieHeader && { Cookie: cookieHeader }) },
  });

  if (!response.ok) {
    throw new Error(
      `Failed to authenticate: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();

  return AuthResponseSchema.parse(data);
}
